import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine3Font2XlBold extends ITextBoxProps {}

export const TextBoxMaxLine3Font2XlBold = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Font2xlBold,
  alignment = TextAligning.Left,
  maxLines = 3,
  ...rest
}: ITextBoxMaxLine3Font2XlBold): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
